import { useTranslation } from 'react-i18next'

import { useDateLimits, useScreen } from '../../../../../hooks'
import { DateTimePicker } from '../../../../DateTime'
import { FormikField } from '../../../../Formik'
import { TASK_FORM_DEADLINE_FIELD_NAME } from '../../TaskForm.constants'

function DeadlineField(props) {
  const { t } = useTranslation()

  const { maxDate, minDate } = useDateLimits()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  return (
    <FormikField
      {...props}
      Component={DateTimePicker}
      borderless={!isMobileScreenSize}
      dateProps={{
        placeholder: t('Task.FormDeadlineFieldDatePlaceholderKey'),
      }}
      fieldComponentProps={{
        label: `${t('Task.FormDeadlineFieldDateLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      maxValue={maxDate}
      minValue={minDate}
      name={TASK_FORM_DEADLINE_FIELD_NAME}
      separator='/'
      timeProps={{
        placeholder: t('Task.FormDeadlineFieldTimePlaceholderKey'),
      }}
    />
  )
}

export default DeadlineField
